module.exports = __webpack_public_path__ + "img/1522250923.ade0a5ed.jpg";